// Contains all config options for the current Klaro! Cookie Consent instance.
var klaroConfig = {
    //testing: true,
    elementID: 'eq-klaro',
    storageMethod: 'cookie',
    storageName: 'eq-klaro',
    htmlTexts: false,
    cookieExpiresAfterDays: 365,
    default: false,
    acceptAll: true,
    hideDeclineAll: false,
    hideLearnMore: false,
    translations: {
        zz: {
            privacyPolicyUrl: '/privacy-policy'
        },
        en: {
            privacyPolicyUrl: '/privacy-policy',
            consentModal: {
                description:
                'Here you can see and customize the information that we collect about you. ' + 
                'We\'ll store your preferences for up to a year. You can change these preferences at any time.'
            },
            purposes: {
                analytics: {
                    title: 'Analytics'
                },
                marketing: {
                    title: 'Marketing'
                }
            }
        }
    },
    services: [
        {
            name: 'google-analytics',
            purposes: ['analytics'],
            translations: {
                zz: {
                    title: 'Google Analytics'
                },
                en: {
                    description: 'We use Google Analytics to track usage of our website.'
                }
            },
            cookies: [
                '_ga',
                '_gid',
                '_gat',
                'AMP_TOKEN',
                '/^_gac_.+$/'
            ],
            onlyOnce: true
        },
        {
            name: 'youtube',
            purposes: ['marketing'],
            translations: {
                zz: {
                    title: "YouTube"
                },
                en: {
                    description: 'We may embed YouTube videos on pages of our site. YouTube is a 3rd party service' +
                                 ' that stores a variety of cookies when you interact with content hosted by YouTube.'
                }
            },
            contextualConsentOnly: true
        },
        {
            name: 'sajari',
            purposes: ['functionality'],
            translations: {
                zz: {
                    title: 'Sajari'
                },
                en: {
                    description: 'We use Sajari to provide search functionality on our site. Sajari uses cookies' +
                                 ' to determine search success. Information about your search is only sent to Sajari when searching our site.'
                }
            },
            cookies: [
                'sjSE',
                'sjID',
                '_ga'
            ],
        },
        {
            name: 'qmod',
            purposes: ['functionality'],
            translations: {
                zz: {
                    title: 'QMod Stock Tools'
                },
                en: {
                    description: "Used by QuoteMedia in their Qmod stock tool suite to verify usage."
                }
            },
            cookies: [
                // Cookie name is dependent on WMID
               'app93303_InteractiveChart',
               'app93303_DayYearRange',
               'app93303_DetailedQuoteTab',
               'app93303_PriceHistory'
            ],
        },
        {
            name: 'eqMajorAnnouncement',
            purposes: ['strictly-necessary'],
            translations: {
                zz: {
                    title: 'Site Announcements'
                },
                en: {
                    description: 'This cookie is used to determine whether or not you\'ve seen an announcement' +
                                 ' we have active so that we don\t show it to you repeatedly.'
                }
            },
            required: true
        },
        {
            name: 'hcaptcha',
            purposes: ['strictly-necessary'],
            required: true,
            translations: {
                zz: {
                    title: 'hCaptcha'
                },
                en: {
                    description: 'We use hCaptcha to protect our forms against spam. You won\'t be able' +
                                 ' to contact us via our web forms unless you allow these cookies.'
                }
            },
            cookies: [
                'hmt_id',
                'INGRESSCOOKIE',
                '__cfduid',
                '__cflb',
                'session',
                'sessionid',
                'hc_accessibility'
            ]
        }
    ]
}